module.exports = __webpack_public_path__ + "img/chat.1bcb9981.svg";